import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";

const resources = {
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
};

let LanguageDetector;

if (typeof window !== "undefined") {
  LanguageDetector =
    require("i18next-browser-languagedetector").default;
}

if (!i18n.isInitialized) {
  if (LanguageDetector) {
    i18n.use(LanguageDetector);
  }

  i18n
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "de",
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "lang",
      },
    })
    .then(() => {
      const currentLng = i18n.language; // z.B. de-DE
      const normalized = currentLng.split("-")[0]; // de
      if (normalized !== currentLng) {
        i18n.changeLanguage(normalized);
      }
    });
}

export default i18n;
